/**
 * @generated SignedSource<<ae024255bfefbbd9539d41ce1f1c26db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LandingPageViewQuery$variables = {};
export type LandingPageViewQuery$data = {
  readonly clientsummary_viewer: {
    readonly financialAccounts: ReadonlyArray<{
      readonly accountName: string;
      readonly clientIdentifier: any;
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"ProfileView_clientsummary_viewer">;
  };
  readonly userprofile_viewer: {
    readonly acceptedTermsVersion: string | null;
    readonly displayName: string;
    readonly email: string;
    readonly firstName: string;
    readonly id: string;
    readonly lastName: string;
    readonly userId: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProfileView_userprofile_viewer">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"GlobalAccountSelectWrapper_query">;
};
export type LandingPageViewQuery = {
  response: LandingPageViewQuery$data;
  variables: LandingPageViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "acceptedTermsVersion",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientIdentifier",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "financialAccountId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LandingPageViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserProfileViewer",
        "kind": "LinkedField",
        "name": "userprofile_viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfileView_userprofile_viewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientSummaryViewer",
        "kind": "LinkedField",
        "name": "clientsummary_viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialAccount",
            "kind": "LinkedField",
            "name": "financialAccounts",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfileView_clientsummary_viewer"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "GlobalAccountSelectWrapper_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "LandingPageViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserProfileViewer",
        "kind": "LinkedField",
        "name": "userprofile_viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountNickname",
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountGroup",
            "kind": "LinkedField",
            "name": "accountGroups",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Account",
                "kind": "LinkedField",
                "name": "accounts",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientSummaryViewer",
        "kind": "LinkedField",
        "name": "clientsummary_viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialAccount",
            "kind": "LinkedField",
            "name": "financialAccounts",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "registrationName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "managementStyle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountTypeAbbreviation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "custodian",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eeb25aec1a92d638bba722dcd76eab89",
    "id": null,
    "metadata": {},
    "name": "LandingPageViewQuery",
    "operationKind": "query",
    "text": "query LandingPageViewQuery {\n  userprofile_viewer {\n    id\n    userId\n    firstName\n    lastName\n    email\n    displayName\n    acceptedTermsVersion\n    ...ProfileView_userprofile_viewer\n  }\n  clientsummary_viewer {\n    financialAccounts {\n      accountName\n      clientIdentifier\n      id\n    }\n    ...ProfileView_clientsummary_viewer\n    id\n  }\n  ...GlobalAccountSelectWrapper_query\n}\n\nfragment GlobalAccountSelectWrapper_query on Query {\n  userprofile_viewer {\n    id\n    accounts {\n      accountNickname\n      financialAccountId\n    }\n    accountGroups {\n      id\n      name\n      accounts {\n        id\n        financialAccountId\n      }\n    }\n  }\n  clientsummary_viewer {\n    financialAccounts {\n      id\n      accountName\n    }\n    id\n  }\n}\n\nfragment ManageAccountGroupView_clientsummary_viewer on ClientSummaryViewer {\n  financialAccounts {\n    id\n    accountName\n    clientIdentifier\n    accountNumber\n    registrationName\n    managementStyle\n    accountType\n    accountTypeAbbreviation\n    custodian\n  }\n}\n\nfragment ManageAccountGroupView_userprofile_viewer on UserProfileViewer {\n  id\n  accounts {\n    accountNickname\n    financialAccountId\n  }\n  accountGroups {\n    id\n    name\n    accounts {\n      id\n      financialAccountId\n    }\n  }\n}\n\nfragment ManageNicknames_clientsummary_data on ClientSummaryViewer {\n  financialAccounts {\n    id\n    accountName\n    accountNumber\n    registrationName\n    managementStyle\n    accountType\n    custodian\n  }\n}\n\nfragment ManageNicknames_userprofile_data on UserProfileViewer {\n  id\n  accounts {\n    accountNickname\n    financialAccountId\n  }\n  accountGroups {\n    id\n    name\n    accounts {\n      id\n      financialAccountId\n    }\n  }\n}\n\nfragment ProfileView_clientsummary_viewer on ClientSummaryViewer {\n  ...ManageAccountGroupView_clientsummary_viewer\n  ...ManageNicknames_clientsummary_data\n}\n\nfragment ProfileView_userprofile_viewer on UserProfileViewer {\n  id\n  displayName\n  accounts {\n    accountNickname\n  }\n  ...ManageAccountGroupView_userprofile_viewer\n  ...ManageNicknames_userprofile_data\n}\n"
  }
};
})();

(node as any).hash = "ceae55d50de8bd37573db637094d88ca";

export default node;
